import { Box, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { ossBaseUrlPracticeFusion } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";

export default function PatientPage() {
  const { state } = useAppContext();

  if (!state.isLoaded) {
    return null;
  }

  const { ehrPatientId } = state;
  if (!ehrPatientId) {
    return (
      <Box>
        <Text>No Patient</Text>
      </Box>
    );
  }

  const ehrDetails = {
    ehrPatientId,
    name: EhrName.PracticeFusion,
  };

  return (
    <Box>
      <SharedStateProvider
        authToken={state.authToken}
        baseUrl={ossBaseUrlPracticeFusion}
        ehrDetails={ehrDetails}
        featureFlags={state.featureFlags}
      >
        {state.featureFlags.shouldShowLegacyDashV1 ? (
          <PatientOverview patientId={ehrPatientId} />
        ) : (
          // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
          <EhrProvider patientId={ehrPatientId} ehrDetails={ehrDetails}>
            <PatientOverviewV2 patientId={ehrPatientId} />
          </EhrProvider>
        )}
      </SharedStateProvider>
    </Box>
  );
}
